import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bcab734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "exhibition" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "after" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_6 = { class: "wapper" }
const _hoisted_7 = {
  key: 0,
  class: "dialog"
}
const _hoisted_8 = { class: "dialog__body" }
const _hoisted_9 = { class: "dialog__body-title" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 这里空空如也~ ")

import { computed, ref } from 'vue'
import { store } from '@remote/store'
import { IconClose } from '@xunlei/thunder-icon-vue'
import { toast } from '@remote/utils/dialog'
import { stat } from '@remote/utils/stat'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: '',
  },
  listTitle: {
    type: String,
    default: '',
  },
  isBottom: {
    type: Boolean,
    default: false,
  },
  clickId: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  nativeClick: {
    type: Boolean,
    default: false,
  },
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props


const showHDialog = ref(false)


const isDownloadTaskNumSettingDisabled = computed(() => {
  return store.state.deviceInfoWatchData.labels?.includes('withoutRunnerCountConfig')
})

const isDownloadSpeedSettingDisabled = computed(() => {
  return store.state.deviceInfoWatchData.labels?.includes('withoutDownloadSpeedConfig')
})

const handleClick = () => {
  if (props.disabled) {
    toast({type: 'error', message: '当前设备已离线，无法设置'})
    return
  }
  if (
    (isDownloadSpeedSettingDisabled.value && props.clickId === 'set_downloadspeed')
    || (isDownloadTaskNumSettingDisabled.value && 'downloadtask_num' === props.clickId)
  ) {
    toast({type: 'error', message: '当前设备不支持该设置项'})
    return
  }
  if (props.clickId) {
    stat({
      action: 'mytab_page_click',
      data: { click_id: props.clickId },
    })
  }
  if (props.nativeClick) {
    emit('click')
  } else {
    showHDialog.value = true
  }
}
const close = () => {
  showHDialog.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["info", { 'is-bottom': __props.isBottom }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick()))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(__props.title) + " ", 1),
            _renderSlot(_ctx.$slots, "title")
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "extra"),
          _renderSlot(_ctx.$slots, "arrow", {}, () => [
            _hoisted_5
          ])
        ])
      ], 2)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_Transition, { name: "mask" }, {
          default: _withCtx(() => [
            (showHDialog.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "cover",
                  onClick: close
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "pop" }, {
          default: _withCtx(() => [
            (showHDialog.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h2", null, _toDisplayString(__props.listTitle), 1),
                      _createVNode(_unref(IconClose), {
                        title: "关闭",
                        onClick: close,
                        width: "20",
                        height: "20"
                      })
                    ]),
                    _renderSlot(_ctx.$slots, "content", { close: close }, () => [
                      _hoisted_10
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ])
    ]))
  ], 64))
}
}

})